{
  "it": {
    "nav": {
      "locations": "Luoghi",
      "home": "Home",
      "back": "Indietro",
      "navigation": "Navigazione",
      "ships": {
        "index": "Navi"
      },
      "compare": {
        "index": "Confronta",
        "ships": "Confronta Navi"
      },
      "manufacturers": "Produttori",
      "images": "Immagini",
      "videos": "Video",
      "shipHistory": "Cronologia",
      "componentHistory": "Cronologia",
      "hangar": {
        "index": "Il Mio Hangar",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventories",
        "vehicleCargo": "Carico",
        "imports": "Importazioni",
        "transfers": "Trasferimenti"
      },
      "login": "Accedi",
      "installApp": "Installa app",
      "logout": "Esci",
      "apiV1": "API v1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginazione",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "embed": "Widget Incorporato",
      "signUp": "Registrati",
      "privacyPolicy": "Informativa sulla privacy",
      "impressum": "Info legali",
      "fleets": {
        "index": "Flotte",
        "add": "Crea una nuova Flotta",
        "invites": "Inviti",
        "ships": "Navi",
        "blueprints": "Progetti",
        "assets": "Beni",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "Mappa mondiale",
          "starmap": "Mappa stellare"
        },
        "squadrons": {
          "index": "Squadroni",
          "overview": "Panoramica",
          "members": "Membri",
          "create": {
            "details": "Dettagli",
            "appearance": "Aspetto",
            "discord": "Discord"
          },
          "edit": {
            "details": "Dettagli",
            "appearance": "Aspetto",
            "discord": "Discord"
          }
        },
        "stats": "Statistiche",
        "logistics": {
          "index": "Logistics"
        },
        "missions": {
          "index": "Missioni",
          "edit": {
            "details": "Dettagli",
            "teams": "Team e slot"
          }
        },
        "events": {
          "index": "Eventi",
          "calendar": "Calendario",
          "edit": {
            "details": "Dettagli",
            "schedule": "Programmazione",
            "signup": "Iscrizione",
            "teams": "Team e slot"
          },
          "payouts": "Pagamenti"
        },
        "tours": "Spedizioni",
        "settings": {
          "index": "Impostazioni",
          "fleet": "Impostazioni Della Flotta",
          "rsi": "ID flotta e RSI",
          "membership": "Impostazioni dei Membri",
          "roles": "Ruoli",
          "squadrons": "Squadroni",
          "allies": "Alleati",
          "notifications": "Notifiche",
          "discord": "Discord",
          "calendar": "Calendario",
          "features": "Funzionalità",
          "contracts": "Contratti"
        },
        "contracts": {
          "index": "Contratti",
          "payouts": "Pagamenti"
        },
        "directory": "Directory"
      },
      "rsiProfile": "Profilo RSI",
      "rsiHangar": "Hangar RSI",
      "tools": {
        "index": "Strumenti",
        "travelTimes": "Tempi di Viaggio",
        "cargoGrids": "Griglie di Carico",
        "tradeRoutes": "Rotte commerciali",
        "tours": "Spedizioni"
      },
      "api": "Documentazione delle API",
      "stats": "Statistiche",
      "toggleSlimCollapse": "Comprimi",
      "toggleSlimExpand": "Espandi",
      "roadmap": {
        "index": "Roadmap",
        "overview": "Panoramica",
        "changes": "Modifiche",
        "ships": "Roadmap Delle Navi"
      },
      "rsiVerification": "Verifica RSI",
      "settings": {
        "index": "Impostazioni",
        "profile": "Profilo",
        "account": "Account",
        "security": "Sicurezza",
        "notifications": "Notifiche",
        "calendar": "Calendario",
        "donations": "Donazioni",
        "hangar": "Hangar",
        "privacy": "Privacy",
        "features": "Funzionalità",
        "connections": "Connessioni",
        "oauthApplications": "App OAuth",
        "verify": "Verifica dell'account RSI",
        "friends": "Amici"
      },
      "reload": "Aggiornamento disponibile!",
      "visualTests": {
        "blueprints": "Progetti",
        "index": "Test Visivi",
        "panels": "Pannelli",
        "buttons": "Pulsanti",
        "events": "Eventi",
        "typography": "Tipografia",
        "forms": "Moduli",
        "tables": "Tabelle",
        "lists": "Elenchi",
        "metrics": "Metriche",
        "states": "Stati",
        "notifications": "Notifiche",
        "syncModal": "Modal sincronizzazione",
        "overlays": "Overlay",
        "installPrompt": "Invito all'installazione",
        "supportHint": "Suggerimento supporto",
        "media": "Media",
        "charts": "Grafici",
        "alerts": "Avvisi",
        "verifiedBadges": "Badge di verifica",
        "chips": "Chips",
        "squadrons": "Squadroni",
        "groups": {
          "foundations": "Fondamenti",
          "data": "Dati",
          "feedback": "Feedback",
          "features": "Funzionalità"
        },
        "notificationCenter": "Centro notifiche",
        "themes": "Temi"
      },
      "admin": {
        "locations": {
          "index": "Luoghi"
        },
        "blueprints": {
          "index": "Progetti"
        },
        "missions": {
          "index": "Missioni"
        },
        "index": "Admin",
        "models": {
          "index": "Modelli",
          "create": "Crea Modello",
          "edit": {
            "index": "Dati di Base",
            "metrics": "Metriche",
            "prices": "Prezzi",
            "docks": "Dock",
            "modules": "Moduli",
            "paints": "Verniciature",
            "images": "Immagini",
            "videos": "Video",
            "cargoAndFuel": "Carico e Carburante",
            "cargoHolds": "Stive di carico",
            "fleetchart": "Immagini Fleetchart",
            "positions": "Posizioni",
            "hardpoints": "Punti di montaggio",
            "loaners": "Prestiti",
            "snubCrafts": "Snub Craft",
            "upgrades": "Upgrade",
            "packages": "Pacchetti",
            "history": "Cronologia"
          }
        },
        "modelPaints": {
          "index": "Vernici",
          "create": "Crea Vernice"
        },
        "modelModules": {
          "index": "Moduli",
          "create": "Crea Modulo",
          "edit": {
            "index": "Dati Base",
            "models": "Modelli",
            "prices": "Prezzi",
            "hardpoints": "Punti di Attacco",
            "docks": "Dock",
            "cargoHolds": "Stive di carico",
            "history": "Cronologia"
          }
        },
        "unlistedModels": {
          "index": "Navi non elencate"
        },
        "modelModulePackages": {
          "index": "Pacchetti Moduli",
          "create": "Crea Pacchetto Moduli"
        },
        "components": {
          "index": "Componenti",
          "edit": {
            "index": "Dati base",
            "prices": "Prezzi",
            "history": "Cronologia"
          }
        },
        "manufacturers": {
          "index": "Produttori",
          "edit": {
            "index": "Dati di base",
            "models": "Navi",
            "components": "Componenti",
            "equipment": "Equipaggiamento",
            "modules": "Moduli"
          }
        },
        "images": {
          "index": "Immagini"
        },
        "users": {
          "index": "Utenti",
          "edit": "Modifica",
          "fleets": "Flotte",
          "inventories": "Inventari",
          "supporterContributions": "Contributi"
        },
        "fleets": {
          "index": "Flotte",
          "edit": "Modifica",
          "members": "Membri",
          "history": "Cronologia",
          "roles": "Ruoli",
          "inventories": "Inventari"
        },
        "fleetFidClaims": {
          "index": "Rivendicazioni FID"
        },
        "destroyedFleets": {
          "index": "Flotte eliminate"
        },
        "vehicles": {
          "index": "Veicoli"
        },
        "admins": {
          "index": "Amministratori"
        },
        "oauthApplications": {
          "index": "App OAuth"
        },
        "maintenance": {
          "index": "Manutenzione",
          "pghero": "PG-Hero",
          "features": "Funzionalità",
          "workers": "Worker",
          "tasks": "Attività",
          "imports": "Importazioni",
          "rsiApiStatus": "Stato API RSI",
          "buildCompare": "Confronto build"
        },
        "announcements": {
          "index": "Annunci",
          "new": "Nuovo annuncio",
          "edit": "Modifica annuncio"
        },
        "supporterContributions": {
          "index": "Contributi dei sostenitori",
          "new": "Nuovo contributo",
          "edit": "Modifica contributo"
        },
        "fundingGoals": {
          "index": "Obiettivi di finanziamento",
          "new": "Nuovo obiettivo di finanziamento",
          "edit": "Modifica obiettivo di finanziamento"
        },
        "notifications": {
          "index": "Notifiche"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "Test Visivi",
          "notifications": "Notifiche"
        },
        "groups": {
          "catalogue": "Catalogo",
          "community": "Community",
          "people": "Persone",
          "system": "Sistema"
        }
      },
      "notifications": "Notifiche",
      "scDataSource": "Fonte dati",
      "commodities": {
        "index": "Merci"
      },
      "components": {
        "index": "Componenti"
      },
      "catalogue": {
        "commodities": "Merci",
        "index": "Catalogo",
        "components": "Componenti",
        "blueprints": "Progetti",
        "missions": "Missioni",
        "equipment": "Equipaggiamento"
      },
      "equipment": {
        "index": "Equipaggiamento"
      }
    }
  }
}
